import {useState} from 'react'
import {useIntl} from 'react-intl'
import {
  SETTINGS_MENU_MESSAGES as M,
  policytoolsRouteLabel,
} from './settingsMenuMessages'
import {hasPermission} from '../../helpers'
import {useGetUser} from '../../store/userStore'
import {Link} from 'react-router-dom'
import {ListGroup} from 'react-bootstrap'
import {KTIcon} from '../../../../_metronic/helpers'
import {ROUTES_POLICYTOOLS_SETTINGS, IPolicytoolsRouteInfo, TOKEN_GENERATOR_ROUTE_ID} from './routesPolicytoolsSettings'
import {GenerateTokenModal} from './GenerateTokenModal'

export const NavPolicytoolsSettingsDesktop = () => {
  const intl = useIntl()
  const permissions = useGetUser((s) => s.user?.permissions) || []
  const userGroups = useGetUser((s) => s.user?.groups)?.map((g: any) => g.name || g) || []
  const [showTokenModal, setShowTokenModal] = useState(false)

  const isRouteVisible = (r: IPolicytoolsRouteInfo) => {
    const hasPerm = r.perm ? hasPermission(permissions, r.perm) : false
    const hasGroup = r.group ? userGroups.includes(r.group) : false
    const gated = Boolean(r.perm) || Boolean(r.group)
    return gated ? hasPerm || hasGroup : true
  }

  const VISIBLE = ROUTES_POLICYTOOLS_SETTINGS.filter(isRouteVisible)

  if (VISIBLE.length === 0) {
    return null
  }

  return (
    <div className='my-0 menu-item d-none d-md-block'>
      <button
        type='button'
        className='btn w-100 btn-sm btn-icon btn-color-light menu-link without-sub'
        data-kt-menu-trigger="{sm: 'click', md: 'hover',lg: 'hover'}"
        data-kt-menu-placement='right-end'
        data-kt-menu-flip='right-end'
      >
        <KTIcon iconName='setting-2' className='fs-2' />
        <span className='menu-title ms-2'>{intl.formatMessage(M.policytoolsSettings)}</span>
      </button>
      <div
        className='menu menu-sub menu-sub-dropdown w-250px'
        data-kt-menu='true'
      >
        <div className='px-7 py-5'>
          <span className='fs-5 text-dark fw-bolder'>
            {intl.formatMessage(M.policytoolsSettings)}
          </span>
        </div>
        <div className='separator border-gray-200'></div>
        <ListGroup style={{border: 0}}>
          {VISIBLE.map((routeInfo) => (
            <ListGroup.Item
              key={routeInfo.id}
              as={Link}
              to={routeInfo.route}
              onClick={(e) => {
                if (routeInfo.id === TOKEN_GENERATOR_ROUTE_ID) {
                  e.preventDefault()
                  setShowTokenModal(true)
                }
              }}
              style={{border: '0', color: '#133159'}}
              className='border-0'
            >
              {policytoolsRouteLabel(intl, routeInfo.route, routeInfo.name)}
            </ListGroup.Item>
          ))}
        </ListGroup>
      </div>

      <GenerateTokenModal show={showTokenModal} onHide={() => setShowTokenModal(false)} />
    </div>
  )
}
